import { Ng2StateDeclaration } from "@uirouter/angular";
import { Error404PageComponent } from "./error.404.component";

export const error404StateDeclaration: Ng2StateDeclaration = {
  name: 'error.404',
  url: "/404",
  component: Error404PageComponent
}
